import React, { useEffect, useState } from "react";
import { FaEllipsisH, FaSearch, FaTimes } from "react-icons/fa";
import Cards from "../../components/AdminSideComponents/Cards";
import bedsLogo from "../../Assets/Logos/BedsLogo.png";
import InmatesLogo1 from "../../Assets/Logos/InmatesLogo.png";
import InmatesLogo from "../../Assets/Logos/InmatesLogo.png";
import issuesLogo from "../../Assets/Logos/IssuesLogo.png";
import MoneyLogo from "../../Assets/Logos/MoneyLogo.png";
import WalletLogo from "../../Assets/Logos/Walletlogo.png";
import bedsOccupied from "../../Assets/Logos/bedsOccupied.png";
import noticesLogo from "../../Assets/Logos/noticesLogo.png";
import bedlogoGreen from "../../Assets/Logos/bedsLogoGreen.png";
import bedlogoYellow from "../../Assets/Logos/bedsLogoYellow.png";
import { useNavigate } from "react-router-dom";
import { MdAddCircle } from "react-icons/md";
import { FaFilter } from "react-icons/fa";
import axios from "axios";

const Availabilty = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterOption, setFilterOption] = useState("All");
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [floorNumber, setFloorNumber] = useState(1);
  const [rooms, setRooms] = useState([]);
  const [status, setStatus] = useState("");
  const [buildingId, setBuildingId] = useState("");
  const [building, setBuilding] = useState([]);
  const [floor, setFloor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bedCounts, setBedCounts] = useState({});
  const navigate = useNavigate();
  const itemsPerPage = 10;

  const items = [
    {
      name: "Number Of Beds Occupied",
      numberOfItems: bedCounts?.totalOccupiedBeds || 0,
      icon: bedsLogo,
    },
    {
      name: "Number of Beds Booked",
      numberOfItems: bedCounts?.totalBookedBeds || 0,
      icon: bedlogoGreen,
    },
    {
      name: "Number Of Beds On Notice",
      numberOfItems: bedCounts?.bedsOnNotice || 0,
      icon: bedlogoYellow,
    },
    {
      name: "Number Of Beds Vacant",
      numberOfItems: bedCounts?.totalVacantBeds || 0,
      icon: bedsOccupied,
    },
  ];

  const getBedCounts = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get_bed_counts`,
      headers: {},
    };
    axios
      .request(config)
      .then((response) => {
        console.log("Response of getBedCounts: ", response.data.data);
        setBedCounts(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
        setBuildingId(response.data.data[0]._id);
        getFloors(response.data.data[0]._id);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
    getBedCounts();
  }, []);

  const getFloors = (id) => {
    console.log("I am floors");
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setFloor(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getConfiguredRoomByBuilding = (floorNumber) => {
    setLoading(true);
    console.log("------>", floorNumber, buildingId);

    setFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setLoading(false);
        setRooms(response.data.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getConfiguredRoomByBuilding(floorNumber);
  }, [buildingId]);

  console.log("I am rooms--->", rooms);
  console.log("I am filterRooms--->", filterOption);

  // Update the filtering logic to include the "All" option
  useEffect(() => {
    let filteredRooms = rooms;

    // Filter by sharingType (filterOption)
    if (filterOption !== "All") {
      filteredRooms = filteredRooms.filter(
        (item) => item.sharingType === filterOption
      );
    }

    // Further filter by status
    if (status === "Full") {
      filteredRooms = filteredRooms.filter((item) => {
        const occupiedBeds = item.beds.filter((bed) => bed.isOccupied === true);
        return occupiedBeds.length === item.numberOfBeds; // Room is full
      });
    } else if (status === "Available") {
      filteredRooms = filteredRooms.filter((item) => {
        const occupiedBeds = item.beds.filter((bed) => bed.isOccupied === true);
        return occupiedBeds.length !== item.numberOfBeds; // Room has availability
      });
    }

    setFilteredRooms(filteredRooms);

    console.log("Filtered Rooms: ", filteredRooms);
  }, [rooms, filterOption, status]);

  console.log("Filtered Rooms: ", filteredRooms);

  useEffect(() => {
    const searchFiltered = rooms.filter((room) => {
      // Format the roomNumber as "R-F{roomNumber}" for searching
      const formattedRoomNumber = `R-F${floorNumber}${String(
        room.roomNumber
      ).padStart(3, "0")}`;

      return Object.entries(room).some(([key, val]) => {
        if (key === "roomNumber") {
          // Check against the formatted roomNumber
          return formattedRoomNumber
            .toLowerCase()
            .includes(searchQuery.toLowerCase());
        }
        // Handle other fields as usual
        return String(val).toLowerCase().includes(searchQuery.toLowerCase());
      });
    });

    setFilteredRooms(searchFiltered);
  }, [searchQuery, rooms]);

  const toggleDropdown = (index) => {
    setShowDropdown(showDropdown === index ? null : index);
  };
  const togglefilterModal = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const totalPages = Math.ceil(filteredRooms.length / itemsPerPage);
  const currentAvailabiity = filteredRooms.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="checkinContainer p-6 bg-primarybgColor">
      <h1 className="text-primaryTextColor  text-[25px] sm:text-[32px] font-bold mb-6">
        Availability
      </h1>
      <Cards items={items} />

      <div className="p-4 bg-[#FFFFFF] shadow-lg mt-6 rounded-lg">
        <div className="flex justify-between items-center mb-4 flex-col md:flex-row">
          <h1 className="text-[18px  mb-2 md:mb-0 text-primaryTextColor sm:text-[24px] font-bold">
            Availability List
          </h1>

          <div className="relative md:flex md:items-center  grid  grid-cols-1  grid-rows-4  gap-2 ">
            {/* Building Name Dropdown */}
            <div className="relative ">
              <select
                className="border border-gray-300 w-full rounded-lg p-2 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                onChange={(e) => {
                  getFloors(e.target.value);
                  setBuildingId(e.target.value);
                }}
              >
                {building?.map((building) => (
                  <option key={building._id} value={building._id}>
                    {building.nameBuilding}
                  </option>
                ))}
              </select>
            </div>
            {/* Floor Number Dropdown */}
            <div className="relative ">
              <select
                onChange={(e) => getConfiguredRoomByBuilding(e.target.value)}
                className="border border-gray-300 w-full rounded-lg p-2 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                defaultValue={floor?.length ? floor[0]?.floorNumber : ""}
              >
                {floor?.map((floor, index) => (
                  <option key={floor._id} value={floor.floorNumber}>
                    Floor-{floor.floorNumber}
                  </option>
                ))}
              </select>
            </div>
            {/* Status Dropdown */}
            <div className="relative">
              <select
                name="status"
                id="status"
                onChange={(e) => setStatus(e.target.value)}
                className="border border-gray-300 w-full rounded-lg p-2 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
              >
                <option value="">Select Status</option>
                <option value="Full">Full</option>
                <option value="Available">Available</option>
              </select>
            </div>
            {/* Search Availbility of rooms */}
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
              />
              <FaSearch className="absolute left-3 top-3 text-secondaryTextColor" />
              {searchQuery && (
                <FaTimes
                  className="absolute right-3 top-3 text-secondaryTextColor cursor-pointer"
                  onClick={handleClearSearch}
                />
              )}
            </div>
            <button
              onClick={togglefilterModal}
              className="relative md:w-[8rem]  flex items-center px-4 gap-2 py-2 bg-gray-200 shadow-xl rounded-md focus:outline-none"
            >
              <FaFilter size={20} className="text-primaryColor" />
              <span className="text-primaryTextColor">Filter</span>
              <svg
                className="w-4 h-4 ml-2 text-secondaryTextColor"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            {isDropdownOpen && (
              <div className="absolute right-0 top-9 w-72 z-50 p-4 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <p className="font-semibold text-primaryTextColor mb-2">
                  SORT BY:
                </p>
                <div className="space-y-2">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value="All"
                      checked={filterOption === "All"}
                      onChange={() => {
                        setIsDropdownOpen(false);
                        setFilterOption("All");
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">All</span>
                  </label>

                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value={1}
                      checked={filterOption === 1}
                      onChange={() => {
                        setIsDropdownOpen(false);
                        setFilterOption(1);
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">
                      1-Sharing
                    </span>
                  </label>

                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value={2}
                      checked={filterOption === 2}
                      onChange={(e) => {
                        setIsDropdownOpen(false);
                        setFilterOption(2);
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">
                      2-Sharing
                    </span>
                  </label>

                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value={3}
                      checked={filterOption === 3}
                      onChange={(e) => {
                        setIsDropdownOpen(false);

                        setFilterOption(3);
                      }}
                      className="text-indigo-500 form-radio"
                    />
                    <span className="ml-2 text-primaryTextColor">
                      3-Sharing
                    </span>
                  </label>

                  <div>
                    <label htmlFor="" className="block text-gray-700 mb-1">
                      Filter by custom sharing type
                    </label>
                    <input
                      type="number"
                      min={1}
                      placeholder="Enter sharing type"
                      className="w-full block p-1 border border-gray-300 rounded-md focus:ring focus:ring-blue-200 outline-none"
                      onInput={(e) => {
                        if (e.target.value) {
                          setFilterOption(Number(e.target.value));
                        } else {
                          setFilterOption("All");
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="overflow-x-auto  min-h-[70vh]">
          <table className="w-[100rem] bg-white border-gray-200 rounded-md">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl">
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Floor Number
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Room Number
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Status
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor ">
                  Sharing Type
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Total Number of Beds
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Number of Beds Available
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Number of Beds On Notice
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Number of Beds Booked
                </th>
              </tr>
            </thead>
            {loading ? (
              // Skeleton loader
              <tbody>
                {Array.from({ length: 20 }).map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : currentAvailabiity.length === 0 ? (
              // No rooms available message
              <tbody>
                <tr>
                  <td
                    colSpan="9"
                    className="py-14 px-6 text-center text-gray-500"
                  >
                    Currently no rooms available!
                  </td>
                </tr>
              </tbody>
            ) : (
              // Render room data
              <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
                {currentAvailabiity.map((item, index) => {
                  const checkRoomIsFull = item.beds.filter(
                    (bed) => bed.isOccupied === true
                  );
                  const showText =
                    checkRoomIsFull.length === item.numberOfBeds
                      ? "Full"
                      : "Available";

                  return (
                    <tr
                      key={index}
                      className="border-b border-gray-200 hover:bg-gray-50"
                    >
                      <td className="py-4 px-6 text-sm text-primaryTextColor">
                        Floor-{item.floorNumber}
                      </td>
                      <td className="py-4 px-6 text-sm text-primaryTextColor">
                        R-F{floorNumber}
                        {String(item.roomNumber).padStart(3, "0")}
                      </td>
                      <td className={`py-4 px-6 text-sm text-center`}>
                        <span
                          className={`${
                            showText === "Available"
                              ? "text-green-700 bg-green-100"
                              : "text-red-700 bg-red-100"
                          } px-4 py-1 rounded-full`}
                        >
                          {showText}
                        </span>
                      </td>
                      <td className="py-4 px-6 text-sm text-primaryTextColor text-center">
                        {item.sharingType}-Sharing
                      </td>
                      <td className="py-4 px-6 text-sm text-primaryTextColor text-center">
                        {item.numberOfBeds}
                      </td>
                      <td className="py-4 px-6 text-sm text-primaryTextColor text-center">
                        {
                          item.beds.filter((bed) => bed.isOccupied === false)
                            .length
                        }
                      </td>
                      <td className="py-4 px-6 text-sm text-primaryTextColor text-center">
                        {
                          item.beds.filter((bed) => bed.underNotice === true)
                            .length
                        }
                      </td>
                      <td className="py-4 px-6 text-sm text-primaryTextColor text-center">
                        {
                          item.beds.filter(
                            (bed) =>
                              bed.isOccupied === true &&
                              bed.underNotice === false
                          ).length
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>

        <div className="flex justify-between items-center mt-4 gap-2 ">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-md ${
              currentPage === 1
                ? "bg-gray-300 text-secondaryTextColor cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            Previous
          </button>
          <span className="text-primaryTextColor">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-md ${
              currentPage === totalPages
                ? "bg-gray-300 text-secondaryTextColor cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Availabilty;
